import { consumeHandoffFragment } from './services/impersonationSession';

// Imported first by index.js. ES modules run in import order, so on /impersonate this flags the tab and takes the
// one-time code out of the URL fragment before any other module evaluates: i18n reads the tab flag for its language
// cache and namespace preload, and analytics must never see the page.
consumeHandoffFragment();
